var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "d-flex justify-content-end" },
      [
        _c(
          "b-button",
          {
            directives: [
              {
                name: "ripple",
                rawName: "v-ripple.400",
                value: "rgba(40, 199, 111, 0.15)",
                expression: "'rgba(40, 199, 111, 0.15)'",
                modifiers: { 400: true },
              },
            ],
            staticClass: "mb-75 no-print",
            attrs: { variant: "outline-success" },
            on: { click: _vm.printSpecificContent },
          },
          [_vm._v(" Print / Download ")]
        ),
      ],
      1
    ),
    _c(
      "div",
      { attrs: { id: "payroll-content" } },
      [
        _c("div", { staticClass: "d-flex justify-content-center" }, [
          _c("h3", [
            _vm._v("PAYSLIP FOR THE MONTH OF " + _vm._s(this.allocationDate)),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "d-flex justify-content-center mt-1" },
          [
            _c(
              "b-row",
              { staticClass: "border w-100" },
              [
                _c(
                  "b-col",
                  { attrs: { cols: "6" } },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          {
                            staticClass:
                              "font-weight-bold p-1 border-bottom border-right",
                          },
                          [_vm._v("Employee Name")]
                        ),
                        _c(
                          "b-col",
                          { staticClass: "p-1 border-bottom border-right" },
                          [_vm._v(_vm._s(_vm.employee.firstName))]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          {
                            staticClass:
                              "font-weight-bold p-1 border-bottom border-right",
                          },
                          [_vm._v("Position")]
                        ),
                        _c(
                          "b-col",
                          { staticClass: "p-1 border-bottom border-right" },
                          [_vm._v(_vm._s(_vm.employee.designationName))]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "b-col",
                  { attrs: { cols: "6" } },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          {
                            staticClass:
                              "font-weight-bold p-1 border-bottom border-right",
                          },
                          [_vm._v("Department")]
                        ),
                        _c(
                          "b-col",
                          { staticClass: "p-1 border-bottom border-right" },
                          [_vm._v(_vm._s(_vm.employee.departmentName))]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { staticClass: "font-weight-bold p-1 border-right" },
                          [_vm._v("Total")]
                        ),
                        _c("b-col", { staticClass: "p-1 border-right" }, [
                          _vm._v("MUR " + _vm._s(this.getTotal)),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._m(0),
        _c("b-table", {
          staticClass: "mt-1",
          attrs: {
            bordered: "",
            responsive: "",
            "head-variant": "light",
            fields: _vm.payrollIncomeFields,
            items: _vm.incomeItems,
          },
          scopedSlots: _vm._u([
            {
              key: "cell(index)",
              fn: function (data) {
                return [_vm._v(" " + _vm._s(data.index + 1) + " ")]
              },
            },
            {
              key: "cell(category)",
              fn: function (data) {
                return [_vm._v(" " + _vm._s(data.item.category) + " ")]
              },
            },
            {
              key: "cell(amount)",
              fn: function (data) {
                return [_vm._v(" " + _vm._s(data.item.amount) + " ")]
              },
            },
            {
              key: "cell(allocationType)",
              fn: function (data) {
                return [_vm._v(" " + _vm._s(data.item.allocationType) + " ")]
              },
            },
          ]),
        }),
        _vm._m(1),
        _c("b-table", {
          staticClass: "mt-1",
          attrs: {
            bordered: "",
            responsive: "",
            "head-variant": "light",
            fields: _vm.payrollDeductionsFields,
            items: _vm.deductionItems,
          },
          scopedSlots: _vm._u([
            {
              key: "cell(index)",
              fn: function (data) {
                return [_vm._v(" " + _vm._s(data.index + 1) + " ")]
              },
            },
            {
              key: "cell(category)",
              fn: function (data) {
                return [_vm._v(" " + _vm._s(data.item.category) + " ")]
              },
            },
            {
              key: "cell(amount)",
              fn: function (data) {
                return [_vm._v(" " + _vm._s(data.item.amount) + " ")]
              },
            },
            {
              key: "cell(allocationType)",
              fn: function (data) {
                return [_vm._v(" " + _vm._s(data.item.allocationType) + " ")]
              },
            },
          ]),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex mt-3 justify-content-center" }, [
      _c("h3", [_vm._v("INCOME")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex mt-3 justify-content-center" }, [
      _c("h3", [_vm._v("DEDUCTION")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }